import React from "react";
import LegalLayout, { Section, Dl } from "../components/LegalLayout";

export default function Tokushoho() {
  return (
    <LegalLayout
      title="特定商取引法に基づく表記"
      description="AdScheの販売事業者・料金・解約/返金ポリシー等の表示です。"
    >
      <Section>
        <Dl>
          <dt>販売事業者</dt><dd>TMS株式会社</dd>
          <dt>運営統括責任者</dt><dd>乙坂 努</dd>
          <dt>所在地</dt><dd>埼玉県さいたま市大宮区桜木町2-3-7F</dd>
          <dt>電話番号</dt>
          <dd>電話番号はご請求があれば遅滞なく開示いたします。</dd>
          <dt>メールアドレス</dt><dd>adsche@tms-ec.co.jp</dd>
          <dt>販売URL</dt><dd>https://adscheauto.com</dd>
          <dt>販売価格</dt><dd>月額 3,980円（税込）</dd>
          <dt>商品代金以外の必要料金</dt>
          <dd>
            <ul>
              <li>インターネット接続に必要な通信料金はお客様負担となります。</li>
              <li>消費税は販売価格に含まれます。</li>
            </ul>
          </dd>
          <dt>引き渡し時期</dt>
          <dd>
            <ul>
              <li>決済完了後、即時にサービスをご利用いただけます。</li>
              <li>初回30日間の無料トライアルは登録完了後すぐにご利用可能です。</li>
              <li>再契約時に無料期間はありません。</li>
            </ul>
          </dd>
          <dt>お支払い方法</dt>
          <dd>
            <ul>
              <li>クレジットカード（Stripe決済）</li>
              <li>無料期間終了後は自動的に月額課金（3,980円/月）に移行します。</li>
            </ul>
          </dd>
          <dt>返品・キャンセル</dt>
          <dd>
            <ul>
              <li>デジタルサービスの性質上、決済後の返金は承っておりません。</li>
              <li>月途中で解約された場合も、日割りでの返金はございません。</li>
            </ul>
          </dd>
          <dt>中途解約</dt>
          <dd>
            <ul>
              <li>解約は次回課金日の前日までにお手続きください。</li>
              <li>解約後は次回課金日以降、自動的にサービス利用が停止されます。</li>
            </ul>
          </dd>
          <dt>動作環境</dt>
          <dd>
            <ul>
              <li>最新版の Google Chrome / Microsoft Edge / Safari</li>
              <li>インターネット接続が必要です。</li>
            </ul>
          </dd>
        </Dl>
      </Section>
    </LegalLayout>
  );
}